<template>
  <div v-if="isShowDetail" class="roomDetailModel1">
    <div class="roomDetailModel-bg1">
      <div class="roomDetailModel-container-box">
        <!-- 内容区域 加减区域 -->
        <div class="small-box" v-if="showSmall">
          <!-- 关闭按钮 -->
          <img @click.stop="onModalClose" :src="currImgUrl + 'close.png'" class="close-icon" mode="" />
          <!-- 标题 -->
          <div class="small-title">
            不知道怎么选房？让我来帮你吧！
          </div>

          <!-- 内容 -->
          <div class="content-small">
            <div class="content-small-title">
              <img :src="currImgUrl + 'peopleIcon.png'" class="content-small-title-img" mode="" />
              <span>请输入出行人数</span>
            </div>

            <div class="content-small-box">
              <div class="small-item">
                <span>18周岁及以上乘客</span>
                <div class="small-item-count">
                  <div class="small-item-count-box">
                    <img v-if="adultCount == 0" class="width-height-44" :src="currImgUrl + 'minus.png'" mode="" />
                    <img v-else class="width-height-44" :src="currImgUrl + 'minGray.png'" mode=""
                      @click.stop="changeAdlCount('mine')" />
                    <span>{{ adultCount }}</span>
                    <img v-if="adultCount == adultCountAll" @click="showCountLimit" class="width-height-44"
                      :src="currImgUrl + 'plusGray.png'" mode="" />
                    <img v-else class="width-height-44" :src="currImgUrl + 'plus.png'" mode=""
                      @click.stop="changeAdlCount('plus')" />
                  </div>
                  <span>人</span>
                </div>
              </div>
              <div class="content-small-box-line"></div>
              <div class="small-item">
                <span>18周岁以下乘客</span>
                <div class="small-item-count">
                  <div class="small-item-count-box">
                    <img v-if="childCount == 0" class="width-height-44" :src="currImgUrl + 'minus.png'" mode="" />
                    <img v-else class="width-height-44" :src="currImgUrl + 'minGray.png'" mode=""
                      @click.stop="changeCheCount('mine')" />
                    <span>{{ childCount }}</span>
                    <img v-if="childCount == childCountAll" @click="showCountLimit" class="width-height-44"
                      :src="currImgUrl + 'plusGray.png'" mode="" />
                    <img v-else class="width-height-44" :src="currImgUrl + 'plus.png'" mode=""
                      @click.stop="changeCheCount('plus')" />
                  </div>
                  <span>人</span>
                </div>
              </div>
              <!-- 提示 -->
              <div class="toest-box" v-if="isShowToast">
                {{ toastText }}
              </div>
            </div>

            <!-- 按钮区域 -->
            <div>
              <!-- 占位置 -->
              <div class="height-50"></div>
              <div class="botton-box" @click.stop="subCountPeple">
                看看推荐
              </div>
            </div>

          </div>

        </div>

        <!-- bgBig -->
        <div v-if="!showSmall" class="big-box">
          <!-- 关闭按钮 -->
          <img @click.stop="onModalClose" :src="currImgUrl + 'close.png'" class="close-icon" mode="" />
          <!-- 标题 -->
          <div class="small-title">
            <span class="color-oringe">{{ adultCount }}大{{ childCount }}小</span> 推荐您入住
          </div>

          <div class="content-small">

            <div class="big-item">
              <div class="big-item-img">
                <img :src="currImgUrl + 'text1.png'" class="big-item-img-i" mode="" />
              </div>
              <div class="big-item-text"
                v-if="cheepData && cheepData.stateroomRecommendationRoomApiViews && cheepData.stateroomRecommendationRoomApiViews.length">
                推荐您入住 <span class="color-blue big-margin-left-6"
                  v-if="cheepData.stateroomRecommendationRoomApiViews[0] && cheepData.stateroomRecommendationRoomApiViews[0].isConnectingRoom == false">{{
                    cheepData.stateroomRecommendationRoomApiViews[0].roomCount }}间</span>
                <span class="color-oringe big-margin-left-6" v-if="cheepData.stateroomRecommendationRoomApiViews[0]">{{
                  cheepData.stateroomRecommendationRoomApiViews[0].recommendationRoomMessage }}
                </span> <span class="big-margin-left-6" v-if="cheepData.stateroomRecommendationRoomApiViews.length > 1">
                  + </span>
                <span class="color-blue big-margin-left-6"
                  v-if="cheepData.stateroomRecommendationRoomApiViews[1] && cheepData.stateroomRecommendationRoomApiViews[1].isConnectingRoom == false">{{
                    cheepData.stateroomRecommendationRoomApiViews[1].roomCount }}间</span>
                <span class="color-oringe big-margin-left-6" v-if="cheepData.stateroomRecommendationRoomApiViews[1]">{{
                  cheepData.stateroomRecommendationRoomApiViews[1].recommendationRoomMessage }}
                </span>
              </div>
            </div>

            <div class="big-item">
              <div class="big-item-img">
                <img :src="currImgUrl + 'text2.png'" class="big-item-img-i" mode="" />
              </div>
              <div class="big-item-text"
                v-if="goodData && goodData.stateroomRecommendationRoomApiViews && goodData.stateroomRecommendationRoomApiViews.length">
                推荐您入住 <span class="color-blue big-margin-left-6"
                  v-if="goodData.stateroomRecommendationRoomApiViews[0] && goodData.stateroomRecommendationRoomApiViews[0].isConnectingRoom == false">{{
                    goodData.stateroomRecommendationRoomApiViews[0].roomCount }}间</span>
                <span class="color-oringe big-margin-left-6" v-if="goodData.stateroomRecommendationRoomApiViews[0]">{{
                  goodData.stateroomRecommendationRoomApiViews[0].recommendationRoomMessage }}
                </span> <span class="big-margin-left-6" v-if="goodData.stateroomRecommendationRoomApiViews.length > 1">
                  + </span>
                <span class="color-blue big-margin-left-6"
                  v-if="goodData.stateroomRecommendationRoomApiViews[1] && goodData.stateroomRecommendationRoomApiViews[1].isConnectingRoom == false">{{
                    goodData.stateroomRecommendationRoomApiViews[1].roomCount }}间</span>
                <span class="color-oringe big-margin-left-6" v-if="goodData.stateroomRecommendationRoomApiViews[1]">{{
                  goodData.stateroomRecommendationRoomApiViews[1].recommendationRoomMessage }}
                </span>
              </div>
            </div>

            <div class="big-item">
              <div class="big-item-img">
                <img :src="currImgUrl + 'text3.png'" class="big-item-img-i" mode="" />
              </div>
              <div class="big-item-text">
                推荐您入住<span class="color-oringe">套房</span>，尊享至多25项套房礼遇，包含管家服务、专属餐厅、优先登离船等。
              </div>
              <div class="color-blue-text" @click.stop="onShowStateroomSuitePopup()">
                （ <span class="color-under-text">具体权益请参考套房礼遇</span> ）
              </div>
            </div>


            <div class="tip-text">
              *推荐房型仅作参考，可能存在售罄或更优方案
            </div>



            <!-- 按钮区域 -->
            <div>

              <!-- 占位置 -->
              <div class="botton-box" @click.stop="backFist">
                重新查询
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    isShowDetail: {
      type: Boolean,
      default: false
    },
    shipCodeHelper: {
      type: String,
      default: ''
    },
    showStateroomSuitePopup: {
      type: Function
    }
  },

  data() {
    return {
      isShowModal: false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      adultCount: 0,
      childCount: 0,

      adultCountAll: 0,
      childCountAll: 0,

      shipSuiteImageMB: '',

      isShowToast: false,
      showSmall: true,

      cheepData: {},
      goodData: {},

      currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',

      toastText: '您房间中的乘客年龄可能不符合线上预订要求，具体请咨询客服'
    }
  },

  watch: {
    isShowDetail: function (val) {
      if (val) {
        this.getCountPeople()
      }
    }
  },


  methods: {
    onShowStateroomSuitePopup() {
      this.showStateroomSuitePopup(this.shipSuiteImageMB);

    },
    closeRoomDetailModel() {
      console.log('closeRoomDetailModelcloseRoomDetailModel')
      this.isShowModal = false
      this.showSmall = true
      this.adultCount = 0
      this.childCount = 0
      this.$emit('closeRoomDetailModel')
    },
    onModalClose() {
      this.isShowModal = false
      this.showSmall = true
      this.adultCount = 0
      this.childCount = 0
      this.$emit('closeRoomDetailModel')
    },
    // 获取人数
    async getCountPeople() {
      // 获取人数上限 获取最大成人数和儿童数
      const res = await api.cruise.getMaxAdultAndChildCount();
      if (res.success) {
        console.log(res, 'resresresres')
        this.adultCountAll = res.data.adultCount
        this.childCountAll = res.data.childCount
      }
    },
    // 加减人数 成人
    changeAdlCount(type) {
      if (type == 'mine') {
        // 减法

        this.adultCount = this.adultCount - 1

      } else {
        // 加法
        if (this.adultCountAll > this.adultCount) {
          this.adultCount = this.adultCount + 1
        }

      }
    },

    // 加减人数 未成年
    changeCheCount(type) {
      if (type == 'mine') {

        this.childCount = this.childCount - 1

      } else {
        // 加法
        if (this.childCountAll > this.childCount) {
          this.childCount = this.childCount + 1
        }
      }
    },

    showCountLimit() {
      if(this.isShowToast) return
      this.isShowToast = true
      this.toastText = '预订人数过多，建议您咨询客服提供更优方案'
      setTimeout(() => {
        this.isShowToast = false
      }, 2000)
    },

    // 提交人数
    async subCountPeple() {
      if (this.adultCount == 0) {
        this.isShowToast = true
        this.toastText = '您房间中的乘客年龄可能不符合线上预订要求，具体请咨询客服'
        setTimeout(() => {
          this.isShowToast = false
        }, 2000)
        return
      }

      // 提交人数
      const res = await api.cruise.getRecommendedRoomsByGuestCount({
        "SailCode": this.shipCodeHelper,
        "AdultCount": this.adultCount, //成人数
        "ChildCount": this.childCount  //儿童数
      });

      if (res.success) {

        if (!res.data.stateroomRecommendationList || res.data.stateroomRecommendationList.length < 1) {

          this.isShowToast = true
          this.toastText = '预订人数过多，建议您咨询客服提供更优方案'
          setTimeout(() => {
            this.isShowToast = false
          }, 2000)
          return
        }

        console.log(res, '提交人数')
        // 切换视图

        this.showSmall = !this.showSmall

        this.cheepData = res.data.stateroomRecommendationList[0]
        this.goodData = res.data.stateroomRecommendationList[1]
        this.shipSuiteImageMB = res.data.shipSuiteImageMB

      } else {

        this.isShowToast = true
        this.toastText = res.errMsg

        setTimeout(() => {
          this.isShowToast = false
        }, 2000)
      }

    },

    // 返回重新提交
    backFist() {
      this.showSmall = !this.showSmall
      this.getCountPeople()
    },

  }
}
</script>

<style lang="less" scoped>
.roomDetailModel1 {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 94px;
  z-index: 103;
}

.roomDetailModel-bg1 {
  background-color: rgba(0, 0, 0, .4);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 94px;

}

.roomDetailModel-container-box {
  background-color: #fff;
  position: absolute;
  width: 100%;
  bottom: 44px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.small-box {
  width: 100%;
  height: 297px;
  background-color: rgba(0, 0, 0, 0.01);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-image: url(https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/bgSmall.png);
}

.content-small {
  width: 351px;
  min-height: 202px;
  background: #FFFFFF;
  border-radius: 8px;
  margin: 0 auto;
  padding: 23px 15px 0;
  box-sizing: border-box;
  position: relative;
  z-index: 3;
}

.content-small-title {
  display: flex;
  align-items: center;

  font-weight: 500;
  font-size: 16px;
  color: #282828;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  margin-bottom: 12px;
}

.content-small-title-img {
  width: 16px;
  height: 17px;
  margin-right: 5px;
}

.width-height-44 {
  width: 22px;
  height: 22px;
}

.color-oringe {
  color: #FF791B;
}

.color-blue {
  color: #006AB6;
}

.color-blue-text {
  margin-top: 5px;
  color: #006AB6;
  font-size: 14px;
}

.color-under-text {
  text-decoration: underline;
}

.height-50 {
  height: 25px;
}

.content-small-box {
  width: 100%;
  height: 100px;
  background: linear-gradient(90deg, #FFF6DA 0%, #FFFFFF 100%);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  padding: 0 9px;
  box-sizing: border-box;
}

.content-small-box-line {
  width: 100%;
  height: 1px;
  background-color: #F3F4F7;
}

.small-item {
  height: 48.5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 400;
  font-size: 16px;
  color: #737373;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.small-item-count {
  display: flex;
  align-items: center;
}

.small-item-count-box {
  width: 84px;
  height: 22px;
  background: #FFF2B5;
  margin-right: 6px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.big-item {
  width: 100%;
  padding: 33px 8px 8px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #FFF9DE 0%, #FFFFFF 100%);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  position: relative;
  margin-bottom: 11px;
}

.big-item-img {
  position: absolute;
  left: 0;
  top: 0;
  width: 83px;
  height: 24px;
  background: linear-gradient(90deg, #FFBF58 0%, #FF781A 100%);
  border-radius: 0px 0px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.big-item-img-i {
  width: 55px;
  height: 14px;
}

.big-item-text {

  font-weight: 400;
  font-size: 14px;
  color: #737373;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.toest-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 320px;

  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  padding: 10px 15px;
  box-sizing: border-box;

  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}

.botton-box {
  margin: 12px auto;
  width: 249px;
  height: 38px;
  background: linear-gradient(270deg, #FFDB17 0%, #FCBF00 100%);
  border-radius: 22px;


  font-weight: 500;
  font-size: 16px;
  color: #353535;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  text-align: center;
  line-height: 38px;
}

.tip-text {
  font-weight: 400;
  font-size: 12px;
  color: #737373;
}

.close-icon {
  width: 14px;
  height: 16px;
  position: absolute;
  right: 14px;
  top: 14px;
}

.small-title {
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: #282828;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  margin-bottom: 6px;
  padding-top: 14px;
  box-sizing: border-box;
}

.big-box {
  width: 100%;
  max-height: 450px;
  /* height: 942rpx; */
  // background-color: rgba(0, 0, 0, 0.01);
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-image: url(https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/bgBig.png);
}

.big-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 80px;
  background-color: #fff;
}
</style>